import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=73fd4131"
import script from "./dashboard.vue?vue&type=script&lang=ts"
export * from "./dashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports